import { callActor } from '../call';
import {
  CallState,
  type CallStatePhoneCallLeavingSubState,
} from '../call/call.types';

type CallActorSnapshot = ReturnType<typeof callActor.getSnapshot>;

export type PhoneCallLeavingReason =
  CallStatePhoneCallLeavingSubState[typeof CallState.PhoneCallLeaving];

const PHONE_CALL_LEAVING_REASONS = new Set<PhoneCallLeavingReason>([
  'providerCanceled',
  'providerCanceledRinging',
  'patientDeclined',
  'patientUnanswered',
  'patientCanceled',
]);

export const getPhoneCallLeavingReason = (
  callMachineState: CallActorSnapshot,
): PhoneCallLeavingReason | undefined => {
  if (typeof callMachineState.value === 'string') {
    return undefined;
  }

  const leavingReason = callMachineState.value[CallState.PhoneCallLeaving];

  if (
    typeof leavingReason === 'string' &&
    PHONE_CALL_LEAVING_REASONS.has(leavingReason as PhoneCallLeavingReason)
  ) {
    return leavingReason as PhoneCallLeavingReason;
  }

  return undefined;
};

export const isPhonePostCallSurveyEligible = (
  leavingReason: PhoneCallLeavingReason | undefined,
): boolean =>
  leavingReason === 'providerCanceled' || leavingReason === 'patientCanceled';
